import api from '@/api';
import { ChatAPITaskRequest, ChatAPITaskResponse } from './tasks.types';

export default {
  async taskFeedback({ taskId, ...payload }: ChatAPITaskRequest) {
    const result = (await api.patch(
      `/chat-api/v1/tasks/${taskId}/status`,
      payload,
      null,
    )) as unknown;
    return result as ChatAPITaskResponse;
  },
};
